<template>
    <div class="page" id="page_glory">
        <header>
            <h2>Our Fame and Glory</h2>
        </header>
        <div class="content-container"> 
        <ul>
        <li>
            <span>
            "Thank you Corporate Travel Services for your excellent support and services in managing our A&H Bangkok Holiday…" <i>Great Eastern Life</i>
            </span>
        </li>
        <li>
            <span>"It was a delightful experience working with CTS as its management and travel consultants are professional, dedicated and helpful. Their focus on customer service is noticeable by all travel service users in YHS…" <i>Yeo Hiap Seng Limited</i>
            </span>
        </li>
        <li>
            <span>"Despite the short notice, CTS was still able to provide us a fantastic service…" <i>Tetra Pak</i>
            </span>
        </li>
        <li>
            <span>"Tour manager's attention to detail ensured that our delegates were happy and well-taken care of. This is reflected in the glowing feedback garnered from our delegates…" <i>TM Asia Life Singapore Ltd</i>
            </span>
        </li>
        <li class="last">
            <span>"The travel consultants at Corporate Travel Services have provided a professional service and have always responded promptly. We sincerely appreciate your responsiveness and the way you conduct business…" <i>Solvay Pharma Singapore Pte Ltd</i>
            </span>
        </li>
        </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Glory'
}
</script>

<style lang="less" scoped>
#page_glory {
    //background: url(../../public/images/bg2.jpg) repeat left top;
    background: @lightColor;

    header {
        background: none;
        margin-bottom: 0;
        padding-bottom: 0;

        h2 {
            color: #444;
            text-align: center;
        }
    }

    li {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // height: 200px;
        list-style: none;
        // border-bottom: 1px solid #e0dedc;
        padding: 40px 20px;
        text-align: center;

        &:last-child {
            border-bottom: none;
        }
    }
    i {
        color: #cc2727;
        display: block;
        font-style: normal;
        text-transform: uppercase;
    }
}

@media only screen and (min-width : 768px) {
    #page_glory {

        ul {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            li {
                margin: 0 2.5%;
                width: 45%;
            }
            li:last-child {
                margin: 0 auto;
            }
        }
    }
}
</style>